const TRANSFERS = {
  BUSINESS: (businessName) => ({
    title: `Do you want to publish this Business: ${businessName}?`,
    message: 'The Business will be published to Production',
    success:
      'Publish complete. The changes will reflect on the Apps within 30 minutes to 1 hour.',
    error: 'There was an error publishing business.',
  }),

  TRIGGERS: () => ({
    title: `Do you want to publish all Prompt Triggers?`,
    message: 'The trigger will be published to Production',
    success:
      'Publish complete. The changes will reflect on the Apps within 30 minutes to 1 hour.',
    error: 'There was an error publishing Prompt Triggers.',
  }),

  SINGLE_TASK: () => ({
    title: `Do you want to publish this task?`,
    message: 'This would publish this task to production',
    success:
      'Publish complete. The changes will reflect on the Apps within 30 minutes to 1 hour.',
    error: 'There was an error publishing Tasks.',
  }),

  TASKS: (businessName) => ({
    title: `Do you want to publish all Menu Options of Business ${businessName}?`,
    message: 'The Menu Options will be published to Production',
    success:
      'Publish complete. The changes will reflect on the Apps within 30 minutes to 1 hour.',
    error: 'There was an error publishing Tasks.',
  }),

  ALL: (businessName) => ({
    title: `Do you want to publish all data associated with this Business ${businessName}?`,
    message:
      'Business, Menu Options and Prompt Triggers will be published to Production',
    success:
      'Publish complete. The changes will reflect on the Apps within 30 minutes to 1 hour.',
    errors: [
      'There was an error in publishing the Business',
      'There was an error in publishing the tasks',
      'There was an error in publishing the Bot Prompt Triggers',
    ],
  }),
};

export default TRANSFERS;
